export default __webpack_public_path__ + "static/media/bet8.1be25f48.png";